import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import "./bank.scss";

import {
  Button,
  Col,
  Form,
  FormCheck,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Texterror } from "../../../constants/Texterror";
import { getSession } from "../../../redux/actions/authActions";
import { getProfile } from "../../../redux/actions/dbactions/profileActions";
import { editServiceUpdate } from "../../../redux/actions/dbactions/ServicesActions";
import {
  bankformsEdit,
  serviceFormVadidations,
} from "../../../constants/Validation";
import { editBankDetails } from "../../../redux/actions/dbactions/bankActions";
import { refTypesList } from "../../../redux/actions/dbactions/refactions";

export const EditModal = ({
  show,
  onHide,
  serviceid,
  setRefresh,
  setEditmodal,
}) => {
  const dispatch = useDispatch();
  const { currentData, isLoading } = useSelector((state) => state.bankReducer);
  const { user_profile_id, role_id, email } = getSession();
  const history = useHistory();
  const [validEmail, setValidEmail] = useState(false);
  const { profile, isLoading: profileLoading } = useSelector(
    (state) => state.profileReducer
  );
  const { refsdata } = useSelector((state) => state.refstypes);
  const {
    svc_bank_bank_name,
    svc_bank_routing_nbr,
    svc_bank_swiftcode,
    svc_bank_iban_code,
    svc_bank_account,
    svc_bank_id,
    bank_acct_holder_name,
    user_email,
  } = currentData;
  const bank_user_profile_id = currentData.user_profile_id;
  const countryname = refsdata.usr?.iso_cntry || [];

  useEffect(() => {
    dispatch(refTypesList());
  }, [dispatch]);

  const handleCountryChange = (event, setFieldValue) => {
    const selectedCountryId = event.target.value;

    setFieldValue("svc_bank_cntry_id", selectedCountryId);
  };

  const handleSubmit = (values) => {
    //values.bank_user_profile_id = bank_user_profile_id;
    values.user_profile_id = bank_user_profile_id
      ? bank_user_profile_id
      : profile.usr?.rec[0]?.user_profile_id;
    dispatch(editBankDetails(values, svc_bank_id));
    setRefresh();
    onHide();
  };
  return (
    <Modal className="editModal profile" show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <h5 className="mb-0">{`Edit Bank x`}</h5>
      </Modal.Header>
      <p>Lorem Ipsum is simply dummy text of the printing.</p>
      <Modal.Body>
        <Formik
          initialValues={{
            user_profile_id: bank_user_profile_id,
            user_email: role_id < 4 ? user_email : email,
            svc_bank_bank_name: svc_bank_bank_name || "",
            svc_bank_routing_nbr: svc_bank_routing_nbr || null,
            svc_bank_swiftcode: svc_bank_swiftcode || null,
            svc_bank_iban_code: svc_bank_iban_code || "",
            svc_bank_account: svc_bank_account || "",
            bank_acct_holder_name: bank_acct_holder_name || "",
            svc_bank_active_yn: "Y",
            svc_bank_cntry_id:
              currentData && currentData.svc_bank_cntry_id
                ? currentData.svc_bank_cntry_id
                : "",

            sys_user_id: user_profile_id,
            role_id: role_id,
          }}
          validationSchema={bankformsEdit}
          onSubmit={handleSubmit}
        >
          {({ touched, errors, values, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={12}>
                  <div className="mb-3">
                    <Form.Label>Account Holder*</Form.Label>
                    <Field
                      className={`form-control ${
                        touched.bank_acct_holder_name &&
                        errors.bank_acct_holder_name
                          ? "is-invalid"
                          : ""
                      }`}
                      name="bank_acct_holder_name"
                      type="text"
                      placeholder="Account holder name"
                      value={values.bank_acct_holder_name}
                      onChange={(e) =>
                        setFieldValue(
                          "bank_acct_holder_name",
                          e.target.value.toUpperCase()
                        )
                      }
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>Bank Country*</Form.Label>
                    <Form.Select
                      className="form-control"
                      name="svc_bank_cntry_id"
                      aria-label="Default select example"
                      onChange={(e) => handleCountryChange(e, setFieldValue)}
                      value={values.svc_bank_cntry_id}
                    >
                      <option value="">Select Country</option>
                      {countryname.map((item, index) => (
                        <option key={index} value={item.iso_cntry_id}>
                          {item.iso_cntry_name}
                        </option>
                      ))}
                    </Form.Select>
                    <ErrorMessage
                      name="svc_bank_cntry_id"
                      component={Texterror}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>Bank Name</Form.Label>
                    <Field
                      className={`form-control ${
                        touched.svc_bank_bank_name && errors.svc_bank_bank_name
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svc_bank_bank_name"
                      type="text"
                      placeholder="Bank Name"
                      value={values.svc_bank_bank_name}
                      onChange={(e) =>
                        setFieldValue(
                          "svc_bank_bank_name",
                          e.target.value.toUpperCase()
                        )
                      }
                    />
                    <ErrorMessage
                      name="svc_bank_bank_name"
                      component={Texterror}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>IBAN Code*</Form.Label>
                    <Field
                      className={`form-control ${
                        touched.svc_bank_iban_code && errors.svc_bank_iban_code
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svc_bank_iban_code"
                      type="text"
                      placeholder="IBAN Code"
                      value={values.svc_bank_iban_code}
                      onChange={(e) =>
                        setFieldValue(
                          "svc_bank_iban_code",
                          e.target.value.toUpperCase()
                        )
                      }
                    />
                    <ErrorMessage
                      name="svc_bank_iban_code"
                      component={Texterror}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>Bank Account Number*</Form.Label>
                    <Field
                      className={`form-control ${
                        touched.svc_bank_account && errors.svc_bank_account
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svc_bank_account"
                      type="text"
                      placeholder="Bank Account Number"
                      value={values.svc_bank_account}
                    />
                    <ErrorMessage
                      name="svc_bank_account"
                      component={Texterror}
                    />
                  </div>
                </Col>
              </Row>
              <Row style={{ marginBottom: "20px" }}>
                <Col lg={6}>
                  <div>
                    <Form.Label>Swift Code</Form.Label>
                    <Field
                      className={`form-control ${
                        touched.svc_bank_swiftcode && errors.svc_bank_swiftcode
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svc_bank_swiftcode"
                      type="text"
                      placeholder="Swift Code"
                      value={values.svc_bank_swiftcode}
                      onChange={(e) =>
                        setFieldValue(
                          "svc_bank_swiftcode",
                          e.target.value.toUpperCase()
                        )
                      }
                    />
                    <ErrorMessage
                      name="svc_bank_swiftcode"
                      component={Texterror}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div>
                    <Form.Label>Routing Number</Form.Label>
                    <Field
                      className={`form-control ${
                        touched.svc_bank_routing_nbr &&
                        errors.svc_bank_routing_nbr
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svc_bank_routing_nbr"
                      type="number"
                      placeholder="Routing Number"
                      value={values.svc_bank_routing_nbr}
                      onChange={(e) =>
                        setFieldValue(
                          "svc_bank_routing_nbr",
                          e.target.value.toUpperCase()
                        )
                      }
                    />
                    <ErrorMessage
                      name="svc_bank_routing_nbr"
                      component={Texterror}
                    />
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col>
                  <div className="d-flex justify-content-between">
                    <Button
                      className="w-full !rounded-md h-[43px] !max-w-28 cancel text-black !text-sm"
                      variant="secondary"
                      onClick={onHide}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="w-full !rounded-md !max-w-28 !text-sm submit"
                      variant="primary"
                      type="submit"
                    >
                      {isLoading ? <Spinner /> : "Submit"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
